module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/274c25f78da1a88c74564ac2ab978f95.png";